import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseComponent } from '../../../core/base/base.component';
import { ProjectUtils, SessionObject, SaveSearchService, GlobalService, ChangeService } from '../../shared';
import { LoaderService, Logger, MyClientServices, TimeOutService } from '../../../core';
import { SecurityCheckForgotpassModel } from './security-check-forgotpass.model';
import { SecurityCheckService } from './security-check-fogotpass.service'

@Component({
  selector: 'app-security-check-forgotpass',
  templateUrl: './security-check-forgotpass.component.html',
  styleUrls: ['./security-check-forgotpass.component.css'],
  providers: [SecurityCheckService, ChangeService]
})
export class SecurityCheckForgotpassComponent extends BaseComponent {

  securityCheckForgotpassModel: SecurityCheckForgotpassModel;
  ngModel: any;
  ischanged: boolean;
  resetUser: any;
  error: any;

  constructor(private router: Router,
    private route: ActivatedRoute,
    protected loaderService: LoaderService,
    protected changeSerive: ChangeService,
    protected globalService: GlobalService,
    protected saveSearchService: SaveSearchService,
    protected securityCheckService: SecurityCheckService,
    protected myClientServices: MyClientServices,
    private timeOutService: TimeOutService,
    private cdr: ChangeDetectorRef
  ) {
    super(loaderService, changeSerive, saveSearchService, securityCheckService, globalService);
    // const sessionData = this.sessionObject.activeCurrentUser;
    this.currentClient = myClientServices.getMyClient();
    this.setroutvalue();
  }

  getLoaderName(): string {
    return 'securityCheckForgotpass';
  }

  getSearchModel(): any {
    if (ProjectUtils.isEmpty(this.securityCheckForgotpassModel)) {
      if (ProjectUtils.isEmpty(this.securityCheckForgotpassModel)) {
        this.securityCheckForgotpassModel = new SecurityCheckForgotpassModel();
      }
    }
    return this.securityCheckForgotpassModel;
  }

  setroutvalue() {
    this.securityCheckForgotpassModel.user_id = this.route.snapshot.queryParamMap.get('user_code');
    this.securityCheckForgotpassModel.question = this.route.snapshot.queryParamMap.get('question');
    this.ngModel = this.securityCheckForgotpassModel.answer;
    this.ngModel = this.securityCheckForgotpassModel.user_id;
  }

  OnSubmit() {
    let body: any = '';
    const clientID = this.currentClient;
    const publisher = this.currentClient;
    body += this.securityCheckService.setParamValue(body, 'question', this.securityCheckForgotpassModel.question);
    body += this.securityCheckService.setParamValue(body, 'user_code', this.securityCheckForgotpassModel.user_id);
    body += this.securityCheckService.setParamValue(body, 'answer', this.securityCheckForgotpassModel.answer);
    body += this.securityCheckService.setParamValue(body, 'password', this.securityCheckForgotpassModel.password);
    body += this.securityCheckService.setParamValue(body, 'publisher', publisher);
    body += this.securityCheckService.setParamValue(body, 'clientID', clientID);
    console.log('body_fogot', body);

    this.resetUser = this.securityCheckService.checksecurity(body).subscribe(data => {

      if (ProjectUtils.isEmpty(data['error'])) {
        this.ischanged = true;
      } else {
        this.error = data['error'];
        this.ischanged = false;
      }
      console.log('To_Reset_Username', data);
    });
  }

  redirectLogin() {
    SessionObject.removeSessionObject();
    this.timeOutService.clearCheckTimeOutSubcription();
    if (this.currentClient) {
      this.router.navigate(['/' + this.currentClient + '/login']);
    } else {
      this.router.navigate(['/']);
    }
    this.cdr.detectChanges();
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/login/security-check-forgotpass/security-check-forgotpass.component.ts